import productGroupFields from "./productGroupFields";
import { applyFrench } from "@lib/applyFrenchField";

const navigationFields = `
"title": ${applyFrench("title", "title_fr")},
"formTitle": ${applyFrench("formTitle", "formTitle_fr")},
url,
'key': _id,
'link': link.link,
'handle': link.document->store.slug.current,
'type': link.document->_type,
'slug': link.document->slug,
'menus': linkgroup[] {
    'key': _key,
    "title": ${applyFrench("title", "title_fr")},
    'links': navigationLinks[] {
        'key': _key,
        "title": ${applyFrench("title", "title_fr")},
        'refTitle': link.document->title,
        'type': link.document->_type,
        'link': link.link,
        'handle': link.document->store.slug.current,
        'slug': link.document->slug,
        "productGroup": *[_type=='productPage' && references(^.link.document->_id) ] {
            ${productGroupFields}
        },
    }
},
`;

export default navigationFields;
